export default "__VITE_ASSET__Bspc$XUZ__"